import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cdp-filter-drawer-button',
    template: `
        <button
            hc-button
            [title]="opened ? 'Close filter drawer' : 'Open filter drawer'"
            [size]="buttonSize"
            buttonStyle="primary-alt"
            (click)="toggleDrawer.emit()"
        >
            <span class="icon-left icon-filters"></span>
            <span *ngIf="opened">Hide Filters</span>
            <span *ngIf="!opened">Show Filters</span>
        </button>
    `,
    standalone: false
})
export class FilterDrawerButtonComponent {
    @Input() opened = false;
    @Input() buttonSize = 'md';
    @Output() toggleDrawer = new EventEmitter<void>();
}
